<template>
  <div>
    <h1 class="text-center">Customer Age Group Report</h1>

    <CreateAgeGroupReport @created="onCreated" />

    <ListAgeGroupReport ref="list" />
  </div>
</template>

<script>
import CreateAgeGroupReport from "@/views/Reports/AgeGroup/CreateAgeGroupReport.vue";
import ListAgeGroupReport from "@/views/Reports/AgeGroup/ListAgeGroupReport.vue";

export default {
  components: {
    CreateAgeGroupReport,
    ListAgeGroupReport,
  },
  methods: {
    onCreated() {
      this.$refs.list?.reload();
    },
  },
};
</script>
